import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 苗字かな
 */
export class FamilyNameKana extends PrimitiveValueObject<string> {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: string): FamilyNameKana {
    const regex = new RegExp(this.validationRule.pattern.value);
    if (!regex.test(value)) {
      throw new Error(this.validationRule.pattern.message);
    }
    return new FamilyNameKana(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '苗字 (保護者, ひらがな)';
  }

  /**
   * プレースホルダー
   */
  static get placeholder(): string {
    return 'やまだ';
  }

  /**
   * タイプ
   */
  static get type() {
    return 'text';
  }

  /**
   * キー
   */
  static get key() {
    return 'familyNameKana';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** パターン */
      /** パターン */
      pattern: {
        /** 値 */
        value: /^([ぁ-ん]){1,128}$/,
        /** メッセージ */
        message: '1文字以上かつ128文字以下かつ「ひらがな」である必要があります',
      },
    };
  }
}
